import favouritesClient from '@/api/favouriteTracks.js'
import { logAddTrackFavourite } from '@/utils/segment.js'

// initial state
const state = {
  favouriteTracks: []
}

// getters
const getters = {
  favouriteTracks (state) {
    return state.favouriteTracks
  },

  favouritesCount (state) {
    return state.favouriteTracks.length
  },

  isFavourite: state => trackPk => {
    return state.favouriteTracks.filter(fave => (fave.item.pk === trackPk)).length > 0
  },

  getFavouritePkFromTrackPk: state => trackPk => {
    const faves = state.favouriteTracks.filter(fave => (fave.item.pk === trackPk))
    if (faves.length > 0) {
      return faves[0].pk
    }
    return null
  }
}

// actions
const actions = {
  fetchFavouriteTracks: (context) => {
    return favouritesClient.listAll()
      .then((data) => {
        context.commit(SET_FAVOURITE_TRACKS, data)
        return data
      })
  },

  fetchFavouriteTracksLite: (context) => {
    return favouritesClient.liteAll()
      .then((data) => {
        // Data coming from the lite API has the track attribute as the PK
        // rather than an object. Munge it into the same format as the full
        // API endpoint for ease.
        const parity = data.map((fave) => {
          return {
            pk: fave.pk,
            item: {
              pk: fave.item
            }
          }
        })
        context.commit(SET_FAVOURITE_TRACKS, parity)
      })
  },

  appendToFavouriteTracks: (context, favourite) => {
    context.commit(APPEND_FAVOURITE_TRACK, favourite)
    // The API returns the favourited track as `item`.
    logAddTrackFavourite(favourite.item.artist.name, favourite.item.display_title)
  },

  removeFromFavouriteTracks: (context, favePk) => {
    const faves = state.favouriteTracks.filter(fave => (fave.pk !== favePk))
    context.commit(SET_FAVOURITE_TRACKS, faves)
  },

  clearFavouriteTracks: (context) => {
    context.commit(SET_FAVOURITE_TRACKS, [])
  }
}

// mutations
const SET_FAVOURITE_TRACKS = 'SET_FAVOURITE_TRACKS'
const APPEND_FAVOURITE_TRACK = 'APPEND_FAVOURITE_TRACK'

const mutations = {
  [SET_FAVOURITE_TRACKS]: (state, payload) => {
    state.favouriteTracks = payload
  },

  [APPEND_FAVOURITE_TRACK]: (state, payload) => {
    state.favouriteTracks.push(payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
